<template>
  <footer class="w-full bg-light-grey p-3">
    <!-- eslint-disable vue/no-v-html -->
    <div class="text-sm break-words text-gray-500" v-html="sanitizedFooter" />
    <!-- eslint-enable vue/no-v-html -->
  </footer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DOMPurify from "dompurify";

const { footer } = defineProps<{
  footer: string;
}>();

const sanitizedFooter = computed(() => {
  if (!footer) {
    return "";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(footer, "text/html");
  const links = doc.querySelectorAll("a");

  links.forEach((link) => {
    const href = link.getAttribute("href");
    if (!href) {
      return;
    }
    if (!href.match(/^(https?:\/\/|\/\/|mailto:|tel:|[[{])/i)) {
      link.setAttribute("href", `https://${href}`);
    }
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });

  return DOMPurify.sanitize(doc.body.innerHTML, {
    ADD_ATTR: ["target", "rel"],
  });
});
</script>
